import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { SSRpage } from "./inner-components";


export const AlertswaringsPage = (props) => {
  return (
    <div className="flexRow full p-0 m-0">
      <div className='full-flex flexCol width100 p-0 m-0'>
        <Routes>
          <Route path="/" element={<SSRpage />} />
          {/* <Route path="/ssr" element={<SSRpage />} /> */}
          {/* <Route path="/irop" element={<IROPpage />} /> */}
        </Routes>
      </div>
    </div>
  )
}
